/**
 * Cor de fundo pastel para células numéricas (Notas V2 demo).
 * Vermelho: nota ≤ metade da nota máxima. Azul: acima da metade.
 */

function parseGradeNumber(value) {
  if (value == null || value === "") {
    return null;
  }
  const t = String(value).trim().replace(",", ".");
  const n = parseFloat(t);
  return Number.isFinite(n) ? n : null;
}

/**
 * @param {string|number} value — nota exibida
 * @param {string|number} maxValueStr — nota máxima da coluna (ex.: "10")
 * @returns {string|undefined} cor CSS ou undefined se sem nota
 */
export function gradeCellBackgroundColor(value, maxValueStr) {
  const n = parseGradeNumber(value);
  const max = parseGradeNumber(maxValueStr != null ? maxValueStr : "10");
  if (n == null || max == null || max <= 0) {
    return undefined;
  }
  const half = max / 2;
  if (n <= half) {
    return "rgba(255, 210, 210, 0.85)";
  }
  return "rgba(200, 220, 255, 0.85)";
}
